<h1>Ügyvédek</h1>
<payee-form-field>
  <payee-autocomplete
    [formControl]="lawFirmSearch"
    [options]="lawFirmOptions"
    [displayWith]="lawFirmDisplayWith"
    (searchChange)="searchChange($event)"
    (ngModelChange)="lawFirmSelected($event)"
  ></payee-autocomplete>
</payee-form-field>
<ul>
  @for (control of form.controls; track control; let i = $index) {
    <li>
      <span>{{ control.value.name }}</span>
      <button
        payee-mini-icon-button
        color="white"
        class="delete-law-firm-button"
        (click)="form.removeAt(i)"
      >
        <payee-icon name="trash-red"></payee-icon>
      </button>
    </li>
  }
</ul>
